import { useQuery } from "react-query";
const endpoint = "https://graphql-onetrust.herokuapp.com/";

function useGetHeadshot(mloHeadShotUrl) {
  const mloHeadShotResolver = `
query GET_MLOHEASHOT_QUERY{
  mloHeadshot(urlLink: "${mloHeadShotUrl}"){
		urlLinkFormatted
		
	}
}


`;
  const { data, isLoading, error } = useQuery(["GET_MLOHEASHOT_QUERY"], () => {
    return fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: mloHeadShotResolver }),
    })
      .then((response) => {
        if (response.status >= 400) {
          throw new Error("Error fetching data");
        } else {
          return response.json();
        }
      })
      .then((data) => {
        return data.data.mloHeadshot.urlLinkFormatted;
      });
  });
  return { data, isLoading, error };
}

export default useGetHeadshot;
